import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { ERROR_DOMAIN, ERROR_PATH } from '@app/constants/errorConstants';
import { getDealerCustomerStores } from '@app/store/dealer-customer/actions';
import { useDispatch, useSelector } from 'react-redux';

const EditOrderInformationFormEffects = () => {
  const { values, setFieldValue } = useFormikContext();
  const dispatch = useDispatch();
  const customerNumber = values.customerNumber?.value;
  const alreadyFetchedCustomerNumber = useSelector(
    s => !!s.dealerCustomer.byId?.[customerNumber]
  );
  const storeId = useSelector(s => s.common.storeId);
  const dealerAssociations =
    useSelector(s => s.dealerAssociation.dealerAssociations) || [];
  const selectedDealerAssociation = dealerAssociations.find(
    da => da.value === storeId
  );

  useEffect(() => {
    const errorPath = {
      domain: ERROR_DOMAIN.CART,
      path: ERROR_PATH.EDIT_ORDER_INFORMATION
    };
    if (customerNumber && !alreadyFetchedCustomerNumber) {
      dispatch(getDealerCustomerStores({ customerNumber, errorPath }));
    }
  }, [alreadyFetchedCustomerNumber, customerNumber, dispatch]);

  const isDealerSet = !!values.dealer;
  useEffect(() => {
    if (selectedDealerAssociation && !isDealerSet) {
      setFieldValue('dealer', selectedDealerAssociation);
    }
  }, [isDealerSet, selectedDealerAssociation, setFieldValue]);

  return null;
};

export default EditOrderInformationFormEffects;
